"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext, useMemo } from "react";
import { TOKENS, type Tokens } from "@intents-explorer/shared-api/tokens";

// Without a provider, components see tokens.json only.
const TokensContext = createContext<Tokens>(TOKENS);
export function TokensProvider(t0) {
  const $ = _c(5);
  const {
    tokenUpdates,
    children
  } = t0;
  let t1;
  if ($[0] !== tokenUpdates) {
    t1 = {
      ...TOKENS,
      ...tokenUpdates
    };
    $[0] = tokenUpdates;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tokens = t1;
  let t2;
  if ($[2] !== children || $[3] !== tokens) {
    t2 = <TokensContext.Provider value={tokens}>{children}</TokensContext.Provider>;
    $[2] = children;
    $[3] = tokens;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useTokens() {
  return useContext(TokensContext);
}